export enum TenantDashboardChartType {
    Metrics = 'metrics',
    Bar = 'bar',
    Pie = 'pie',
    Line = 'line',
}
